export default __webpack_public_path__ + "static/media/bed.1cba79fe.svg";